module.exports = __webpack_public_path__ + "static/img/product03-5.1869cd58.png";